import React from 'react';
import { LegalLayout, H2, P, UL } from './LegalLayout';

/** Cookie Policy — DRAFT scaffold. */

export default function CookiePolicy() {
  return (
    <LegalLayout
      title="Cookie Policy"
      description="How Kids WiseApp uses cookies and similar technologies — what they are, what we set, and how you can control them."
      canonical="https://kidswiseapp.com/cookies"
      lastUpdated={new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
    >
      <P>
        This page explains how Kids WiseApp uses cookies and similar
        browser-storage technologies (localStorage, sessionStorage,
        service-worker caches). For details on how we handle personal
        data more generally, see our{' '}
        <a href="/privacy">Privacy Policy</a>.
      </P>

      <H2>What are cookies?</H2>
      <P>
        Cookies are small data files a website stores on your device
        to remember information between visits — like keeping you
        signed in, or remembering your last-used centre. We also use
        related technologies such as <em>localStorage</em> (a
        persistent in-browser key-value store) and
        <em> service workers</em> (background scripts that make the
        app work offline as a PWA).
      </P>

      <H2>Categories we use</H2>
      <H2>1. Strictly necessary</H2>
      <P>
        Required to make the platform work. These cannot be disabled
        without breaking core functionality.
      </P>
      <UL>
        <li><strong>Auth token</strong> (localStorage) — keeps you signed in between page loads.</li>
        <li><strong>Selected organisation / centre</strong> (localStorage) — remembers your last-used context.</li>
        <li><strong>Service worker caches</strong> — make the app installable and usable on a flaky network.</li>
        <li><strong>CSRF protection</strong> (session) — prevents cross-site request forgery.</li>
      </UL>

      <H2>2. Functional</H2>
      <UL>
        <li><strong>UI preferences</strong> — theme, sidebar collapsed state, last-used filters.</li>
        <li><strong>Cookie-consent decision</strong> — once you choose, we remember your answer for 12 months.</li>
      </UL>

      <H2>3. Analytics (not yet active)</H2>
      <P>
        We do <strong>not currently run any analytics or marketing
        cookies</strong>. If we add a privacy-preserving analytics
        provider (e.g. Plausible or Fathom) in future, we will update
        this page and present a consent prompt before enabling it.
      </P>

      <H2>How to control cookies</H2>
      <P>
        You can clear cookies and localStorage from your browser's
        settings at any time. Note: clearing the auth token will sign
        you out, and clearing localStorage will reset your saved UI
        preferences. On iOS/Android, removing the homescreen shortcut
        and reinstalling will clear all PWA caches.
      </P>

      <H2>Third-party cookies</H2>
      <UL>
        <li><strong>Mollie</strong> — when you reach a checkout page, Mollie sets its own anti-fraud cookies. See <a href="https://www.mollie.com/en/privacy" target="_blank" rel="noopener noreferrer">Mollie&apos;s privacy &amp; cookies policy</a>.</li>
        <li><strong>Google Fonts</strong> — fonts are loaded from Google's CDN; Google may set its own cookies on the font requests.</li>
      </UL>

      <H2>Updates</H2>
      <P>
        We'll update this policy when we change the cookies we set.
        Material changes are announced in-app.
      </P>
    </LegalLayout>
  );
}
